import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Button,
  Card,
  CardHeader,
  Chip,
  Divider,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip
} from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

const LatestOrders = (props) => {
  const navigate = useNavigate();
  const { offers } = props;
  const orders = offers;

  const seeOffer = (clientId, offerId) => {
    navigate(`/app/myOffer/${clientId}/${offerId}`, { replace: true });
  };

  return (
    <Card {...props}>
      <CardHeader title="Últimas Negociações" />
      <Divider />
      <PerfectScrollbar>
        <Box sx={{ minWidth: 800 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  Número
                </TableCell>
                <TableCell>
                  Ofertante
                </TableCell>
                <TableCell>
                  Produto
                </TableCell>
                <TableCell>
                  Dono do Produto
                </TableCell>
                <TableCell sortDirection="desc">
                  <Tooltip
                    enterDelay={300}
                    title="Sort"
                  >
                    <TableSortLabel
                      active
                      direction="desc"
                    >
                      Date
                    </TableSortLabel>
                  </Tooltip>
                </TableCell>
                <TableCell>
                  Status
                </TableCell>
                <TableCell>
                  Visualizar
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orders.map((order) => (
                <TableRow
                  hover
                  key={order.id}
                >
                  <TableCell>
                    {order.id}
                  </TableCell>
                  <TableCell>
                    {order.client.name}
                  </TableCell>
                  <TableCell>
                    {order.product.name}
                  </TableCell>
                  <TableCell>
                    {order.client_product.name}
                  </TableCell>
                  <TableCell>
                    {moment(order.created_at).format('DD/MM/YYYY')}
                  </TableCell>
                  <TableCell>
                    <Chip
                      color="primary"
                      label={order.status}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <IconButton
                      edge="end"
                      size="small"
                    >
                      <VisibilityIcon onClick={() => { seeOffer(order.client_id, order.id); }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          p: 2
        }}
      >
        <Button
          sx={{ display: 'none' }}
          color="primary"
          endIcon={<ArrowRightIcon />}
          size="small"
          variant="text"
        >
          View all
        </Button>
      </Box>
    </Card>
  );
};

LatestOrders.propTypes = {
  offers: PropTypes.array,
};

export default LatestOrders;
